import React from "react";

import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import SvgIconStyle from "../../../components/SvgIconStyle";
import { avataStyles, svgIconStyle } from "../../DonationView/Cart/styles";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ProfileAndBanner from "./ProfileAndBanner";
import DonationTab from "./DonationTab";
import TabPanel from "../../../components/TabPanel";
import Detail from "./Detail";
import DonationProducts from "../../DashBoardView/Actions/ActionCard/DonationProducts/DonationProducts";
import {
  CollectionStatus,
  ComponentType,
  DonationStatus,
} from "../../../common/enum";
import EmptyMessage from "../EmptyMessage";
import DonationCollection from "./DonationCollection";
import ConfirmDialog from "../../../components/ConfirmDialog";

import { useDispatch, useSelector } from "react-redux";
import { addRating, updateDonation } from "../../DonationView/slice";
import {
  getMyActiveDonation,
  setMyActiveDonationsLimit,
  setMyActiveDonationsOffset,
  setMyActiveDonationsPage,
} from "../../DashBoardView/slice";
import {
  setSnackbarOpen,
  setSnackbarMessage,
  setSnackbarSeverity,
} from "../../AdminView/adminSlice";
import { useSnackbar } from "notistack";
import Avatar from "@mui/material/Avatar";
import { Rating, Typography, useTheme} from "@mui/material";
import { useCollection } from "../../DashBoardView/Actions/ActionDate/useCollection";
import { EntityType } from "../../../common/enum";
import styled from "@emotion/styled";
import EventProductDonation from "../../DashBoardView/Actions/ActionCard/DonationProducts/EventProductDonation";

const STATUS_PRESENT = {
  cancel: DonationStatus.cancel,
  collected: DonationStatus.collected,
  expired: DonationStatus.expired,
};

const DonationDrawer = ({
  drawerState,
  toggleDrawer,
  donationDetail,
  donationStatus,
  donationFilter,
  t,
  component,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const {
    auth: {
      profile: { entity },
    },
    dashboardInfo: {
      myActiveDonationsTotalCount,
      myActiveDonationsOffSet,
      myActiveDonationsLimit,
      myActiveDonationsPage,
      entityProfileSelect,
    },
  } = useSelector((state) => state);
  const { userId, entityId } = entity || "";
  const { enqueueSnackbar } = useSnackbar();
  const [tabValue, setTabValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [motive, setMotive] = React.useState("");
  const [motiveError, setMotiveError] = React.useState(false);
  const [openType, setOpenType] = React.useState("");
  const [ratingValue, setRatingValue] = React.useState(0);
  const rate = React.useRef();
  rate.current = ratingValue;
  const [ratingError, setRatingError] = React.useState(false);
  const { setMonthStartDate, setMonthEndDate, setKey } = useCollection();

  const OPEN_TYPE = {
    cancel: "CANCEL",
    evaluate: "EVALUATE",
  };

  const setParticularTabValue = React.useCallback((val) => {
    setTabValue(val);
  }, []);

  const handleClick = React.useCallback(() => {
    toggleDrawer(false);
  }, []);

  const cancelHandle = React.useCallback(() => {
    setOpen(true);
    setOpenType(OPEN_TYPE.cancel);
   
  }, []);

  const handleClose = React.useCallback(() => {
    setOpen(false);
    setMotive("");
    setMotiveError(false);
    setRatingError(false);
    setRatingValue(0);
  }, []);

  const cancelDonation = React.useCallback((status) => {
    let payload = {};
    payload["donationId"] = donationDetail?.donation?.donationId;
    payload["status"] = DonationStatus.cancel;
    payload["updatedBy"] = userId;
    payload["addressId"] = donationDetail?.donation?.addressId;
    payload["isPublish"] = true;
    payload["isAnimal"] = donationDetail?.donation?.isAnimal;
    payload["consumedByDate"] = donationDetail?.donation?.consumeByDate;
    payload["note"] = status.length > 0 ? status : donationDetail?.donation?.note;
    payload["availableFromDate"] = donationDetail?.donation?.availableFromDate;
    payload["availableToDate"] = donationDetail?.donation?.expiryDate;
    dispatch(updateDonation(payload))
      .unwrap()
      .then((res) => {
        const data = {
          limit: myActiveDonationsLimit,
          offset: myActiveDonationsOffSet,
          status: donationStatus,
        };
        if (donationFilter.donor || donationFilter.event) {
          let isEvent = donationFilter.event ? true : false;
          data["isEvent"] =
            donationFilter.donor && donationFilter.event ? null : isEvent;
        }
        data["entityId"] = entityId;
       
        if(donationDetail.donation.isEvent == true){
          enqueueSnackbar({
            message: 'Evento cancelado com sucesso.',
            variant: "success",
          });
        }else{
          enqueueSnackbar({
            message: t("donationCancelledSuccessfully"),
            variant: "success",
          });
        }
        
        setOpen(false);
        setMotive("");

        dispatch(getMyActiveDonation(data));
        dispatch(setMyActiveDonationsLimit(10));
        dispatch(setMyActiveDonationsOffset(0));
        dispatch(setMyActiveDonationsPage(myActiveDonationsPage));
        dispatch(getMyActiveDonation(data));

      })
      .catch(() => {
        enqueueSnackbar({
          message: t("someThingWentWrong"),
          variant: "error",
        });
      });
  }, [dispatch, donationDetail]);

  const onConfirm = React.useCallback(async () => {
    if (openType === OPEN_TYPE.cancel) {
      if (motive.length === 0) {
        setMotiveError(true);
      } else {
        cancelDonation(motive);
      }
    } else {
      if (ratingValue > 0) {
        await confirmDonation(CollectionStatus.collected);
      } else {
        setRatingError(true);
      }
    }
  }, [openType, component, motive, ratingValue]);

  const evaluateHandle = React.useCallback(() => {
    setOpen(true);
    setOpenType(OPEN_TYPE.evaluate);
  }, []);

  const confirmDonation = React.useCallback(() => {
    let payload = {};
    payload["donationId"] = donationDetail?.donation?.donationId;
    payload["status"] = DonationStatus.collected;
    payload["updatedBy"] = userId;
    payload["addressId"] = donationDetail?.donation?.addressId;
    payload["isPublish"] = true;
    payload["note"] =
      motive.length > 0 ? motive : donationDetail?.donation?.note;
    payload["availableFromDate"] = donationDetail?.donation?.availableFromDate;
    payload["availableToDate"] = donationDetail?.donation?.expiryDate;
    dispatch(updateDonation(payload))
      .unwrap()
      .then((res) => {
        rateCollectionDonation();
        const data = {
          limit: myActiveDonationsLimit,
          offset: myActiveDonationsOffSet,
          status: donationStatus,
        };
        if (donationFilter.donor || donationFilter.event) {
          let isEvent = donationFilter.event ? true : false;
          data["isEvent"] =
            donationFilter.donor && donationFilter.event ? null : isEvent;
        }
        data["entityId"] = entityId;
        dispatch(getMyActiveDonation(data));
        dispatch(setMyActiveDonationsLimit(10));
        dispatch(setMyActiveDonationsOffset(0));
        dispatch(setMyActiveDonationsPage(myActiveDonationsPage));
        enqueueSnackbar({
          message: t("donationCollectedSuccessfully"),
          variant: "success",
        });
        setOpen(false);
        setMotive("");
      })
      .catch(() => {
        enqueueSnackbar({
          message: t("someThingWentWrong"),
          variant: "error",
        });
      });
  }, [dispatch, donationDetail]);

  const rateCollectionDonation = React.useCallback(() => {
    const payload = {
      donationId: donationDetail?.donation?.donationId,
      createdBy: userId,
      rating: rate.current,
      feedback: motive,
    };
    dispatch(addRating(payload))
      .unwrap()
      .then((res) => {
        const currentDate = new Date();
        const firstDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        );
        const lastDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          0
        );
        setMonthStartDate(moment(firstDate).format("YYYY-MM-DD"));
        setMonthEndDate(moment(lastDate).format("YYYY-MM-DD"));
        setKey(Math.random());
        enqueueSnackbar({
          message: t("collectionFeedbackSuccessfully"),
          variant: "success",
        });
        setOpen(false);
        setRatingValue(0);
        setMotive("");
      })
      .catch(() => {
        enqueueSnackbar({
          message: t("someThingWentWrong"),
          variant: "error",
        });
      });
  }, [dispatch, ratingValue, motive, setMonthStartDate, setMonthEndDate]);
  return (
    <>
      <Drawer
        anchor={"right"}
        open={drawerState}
        onClose={() => toggleDrawer(false)}
        PaperProps={{
          sx: {
            width: "50%",
            [theme.breakpoints.down("md")]: {
              width: "100%",
            },
          },
        }}
      >
        <Button
          sx={{
            position: "fixed",
            right: "51%",
            top: 10,
            zIndex: 1,
            minWidth: 0,
            borderRadius: "4px",
            padding: "4px",
            backgroundColor: "#ffc3c3",
            "&:hover": {
              backgroundColor: "#ffc3c3",
            },
            [theme.breakpoints.down("md")]: {
              right: "1%",
            },
          }}
          onClick={handleClick}
        >
          <CloseOutlinedIcon color="error" />
        </Button>
        <ProfileAndBanner
          entityLeastDetails={donationDetail?.entityLeastDetails}
          donationId = { Object.keys(donationDetail).length > 0
            ? `${new Date(
              donationDetail?.donation?.createdDate
              ).getFullYear()}${donationDetail?.donation.id}`
            : ""}
        />
        <Box sx={{ width: "100%", mt: 5 }}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              display: "flex",
              justifyContent: "space-between",
              pr: 1,
            }}
          >
            {" "}
            <DonationTab
              tabValue={tabValue}
              setParticularTabValue={setParticularTabValue}
              t={t}
            />
            {!Object.values(STATUS_PRESENT).includes(
              donationDetail?.donation.status
            ) &&(entity?.entityType === EntityType.donor ||
              entityProfileSelect === EntityType.donor) &&
              (entity?.isParentEntity === false ||
                entity?.parentEntityId !== null ||
                entity?.isGroupEntity === false) && (donationDetail?.donation.consumeByDate && new Date(donationDetail?.donation.consumeByDate) > new Date() || new Date(donationDetail?.donation.expiryDate) > new Date() ) 
                 &&(
              <>
                {/* <Button
                      variant="contained"
                      sx={{ m: 1,marginLeft:'150px' }}
                      onClick={evaluateHandle}
                    >
                      {t("collected")}
                    </Button> */}
                <Button
                  color="error"
                  sx={{
                    background: "#FFEEEE",
                    color: "#FF0000",
                    my: 1,
                    "&:hover": { background: "#FF0000", color: "#FFEEEE" },
                    borderRadius:"4px"
                  }}
                  onClick={cancelHandle}
                >
                  {t("cancel")}
                </Button>
              </>
            )}
          </Box>

          <TabPanel value={tabValue} index={0}>
            <Detail donationDetail={donationDetail} t={t} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={1}
            style={{ padding: "8px", marginTop: "16px" }}
          >
            {donationDetail.donation.isEvent &&
              donationDetail.donationProducts.length === 0 && (
                <EventProductDonation
                donation={donationDetail}
                t={t}
                componentType={ComponentType.DONATION}
              />
                // <EmptyMessage message={"noProductForThisDonation"} t={t} />
              )}
              {donationDetail.donation.isEvent &&
              donationDetail?.eventosRecolhidos?.length === 0 && (
                <EmptyMessage message={"noProductForThisDonation"} t={t} />
             
              )}
            {!donationDetail.donation.isEvent &&
              donationDetail.donationProducts.length !== 0 && (
                <DonationProducts
                  donation={donationDetail}
                  t={t}
                  componentType={ComponentType.DONATION}
                />
              )}
          </TabPanel>
          <TabPanel value={tabValue} index={2} >
            {donationDetail.collectionCount === 0 && (
              <Box sx={{textAlign:"-webkit-center"}} pt={3}>
                 <Avatar sx={avataStyles}>
                <SvgIconStyle src="/static/dashboard/box.svg" sx={svgIconStyle} />
                
              </Avatar>
                <Typography>{t("noCollectionForThisDonation")}</Typography>
              </Box>
             
              // <EmptyMessage message={"noCollectionForThisDonation"} t={t} />
            )}
            {donationDetail.collectionCount > 0 && (
              <DonationCollection
                donationId={donationDetail.donation.donationId}
                t={t}
              />
            )}
          </TabPanel>
        </Box>
      </Drawer>
      <ConfirmDialog
        open={open}
        handleClose={handleClose}
        title={
          component === ComponentType.DONATION
            ? openType === OPEN_TYPE.cancel
              ? donationDetail.donation.isEvent ? 'Tem a certeza que deseja cancelar este evento?' : t("cancelCollectionDialogTitle")
              : t("evaluateDonation")
            : t("cancelDontaionDialogTitle")
        }
        content={
          <React.Fragment>
            {openType === OPEN_TYPE.evaluate && (
              <>
                <Rating
                  component="span"
                  name="simple-controlled"
                  defaultValue={ratingValue}
                  value={ratingValue}
                  onChange={(event, newValue) => {
                    setRatingValue(newValue);
                    setRatingError(false);
                  }}
                 // precision={0.1}
                />
                {ratingError && (
                  <Typography variant="subtitle2" color="error">
                    O campo é de preenchimento obrigatório
                  </Typography>
                )}
              </>
            )}
            <TextField
              sx={{ width: "100%", mt: 1 }}
              label={'Motivo...'}
              multiline
              minRows={4}
              value={motive}
              onChange={(e) => {
                setMotive(e.target.value);
                setMotiveError(false);
              }}
              required={openType === OPEN_TYPE.cancel ? true : false}
              error={motiveError}
              helperText={
                motiveError &&
                `O campo ${t("remarks")} é de preenchimento obrigatório`
              }
            />

          </React.Fragment>
        }

       
         
          onConfirm={onConfirm}
          cancelButtonTitle={t("cancel")}
          confirmButtonTitle={t("confirm")}
        
       
      />
    </>
  );
};

export default DonationDrawer;
